import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { UserService } from '@services/user.service';
import { ConfirmDialogService } from '@utils/confirm-dialog.service';
import { ToastService } from '@utils/toast.service';
import { CreateBankGroupComponent } from './create-bank-group/create-bank-group.component';
import { UpdateBankGroupComponent } from './update-bank-group/update-bank-group.component';

@Component({
  selector: 'app-bank-group',
  imports: [CommonModule, DrawerModule, ButtonModule, TableModule, CreateBankGroupComponent, UpdateBankGroupComponent],
  templateUrl: './bank-group.component.html',
  styleUrl: './bank-group.component.scss',
})
export class BankGroupComponent {
  private userService = inject(UserService);
  private confirmDialogService = inject(ConfirmDialogService);
  private toastService = inject(ToastService);

  @Input() createDrawerVisible: boolean = false;
  @Output() createDrawerVisibleChange = new EventEmitter<boolean>();

  @Input() updateDrawerVisible: boolean = false;
  @Output() updateDrawerVisibleChange = new EventEmitter<boolean>();

  public isDeleting = false;
  public listBankGroup: any[] = [];
  public bankGroupIdEditing: any = null;

  ngOnInit(): void {
    this.loadBankGroupData();
  }

  loadBankGroupData(): void {
    this.userService.listBankGroup().then((response: any) => (this.listBankGroup = response.content));
  }

  updateBankGroup(id: any): void {
    this.bankGroupIdEditing = id;
    this.updateDrawerVisible = true;
    this.updateDrawerVisibleChange.emit(this.updateDrawerVisible);
  }

  delete = (event: Event, id: any) => {
    this.isDeleting = true;

    this.confirmDialogService
      .dialog(event, 'Al eliminar este grupo de bancos, los usuarios se desasociarán de él.', 'Continuar', 'Cancelar')
      .then(() => {
        this.userService
          .deleteBankGroup(id)
          .then(() => {
            this.toastService.success('Grupo de bancos eliminado con éxito.');
            this.ngOnInit();
          })
          .catch((error: any) => {
            this.toastService.error(error.error?.data?.message);
            this.isDeleting = false;
          });
      })
      .catch(() => (this.isDeleting = false));
  };
}
